import { useDrop } from 'react-dnd'
import { NativeTypes } from 'react-dnd-html5-backend'
import { CardImage } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import styles from '../Shop.module.css'
import { Button, Form } from 'react-bootstrap';

export const DropBox = (props) => {
  const { t } = useTranslation();
  const { onDrop, onClick } = props;
  const [{ canDrop, isOver }, drop] = useDrop(
    () => ({
      accept: [NativeTypes.FILE],
      drop(item) {
        if (onDrop) {
          onDrop(item)
        }
      },
      canDrop(item) {
        // console.log('canDrop', item.files, item.items)
        return true
      },
      hover(item) {
        // console.log(item)
        // console.log('hover', item.files[0], item.items)
      },
      collect: (monitor) => {
        const item = monitor.getItem()
        if (item) {
          // console.log('collect', item.files[0], item.items)
        }
        return {
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop(),
        }
      },
    }),
    [props],
  )
  const isActive = canDrop && isOver
  return (
    <div className={`${styles.listItem} w-100 ${isActive ? 'bg-light': ''} rounded d-flex flex-wrap justify-content-center align-items-center text-black-50 ${styles.dashed} p-5`} ref={drop}>
        <CardImage size={96} className='w-100'/>
        {
            isActive ?
            'Release to drop'
            :
            <div className='d-flex flex-wrap justify-content-center text-center'>
                <p className='w-100 mb-1'>
                    {t('Drag file here')}
                    <br/>
                    {t('or')}
                </p>
                <Button className='p-1 fs-6 mb-2' variant='outline-secondary' size='sm' onClick={e => onClick(e)}>{t('Add file')}</Button>
            </div>
        }
    </div>
  )
}

export default DropBox
